import { useFunnelName } from 'core/funnel/hooks';
import { useAnalytics } from './useAnalytics';

export const useEmailAnalytics = () => {
  const { funnelName } = useFunnelName();
  const { trackCustomEvent } = useAnalytics();

  const defaultProperties = {
    funnel_context: funnelName,
    screen_context: 'email_form',
    funnel_platform: 'AppNebula',
  };

  const trackFirstEmailTouch = () => {
    trackCustomEvent('funnel_screen_click', {
      ...defaultProperties,
      action: 'click_to_fill',
    });
  };

  const trackFirstEmailChange = () => {
    trackCustomEvent('funnel_screen_click', {
      ...defaultProperties,
      action: 'start_to_fill',
    });
  };

  return {
    trackFirstEmailTouch,
    trackFirstEmailChange,
  };
};
